export default "/_next/static/images/service-sitting-desktop-2x-d3fc8694f46015bdd39e7e272e8264d4.jpg";